var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-menu-container"},[_c('button',{staticClass:"back",attrs:{"to":_vm.to},on:{"click":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('i',{staticClass:"icon-arrow-b"})]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('h3',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82fa255a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/MobileBackMenu.vue
// module id = 1222
// module chunks = 0 1 4 7